import cls from 'classnames'
import { CSSProperties, EventHandler, MouseEvent, ReactNode } from 'react'
import styles from './AButton.module.less'
import { LoadingSpinner } from './components/LoadingSpinner/LoadingSpinner'

const COMPONENT_NAME = 'A-Button'

export interface AButtonProps {
  size?: 'XXS' | 'XS' | 'SM' | 'NOR' | 'LG' | 'LG-AUTO' | 'LGR'
  type?: 'primary' | 'outlined'
  hover?: 'primary' | 'outlined'
  shape?: 'default' | 'circle' | 'round'
  textWeight?: 'bold' | 'normal'
  disabled?: boolean
  loading?: boolean
  /** 高亮按钮*/
  highlight?: boolean
  children?: ReactNode
  className?: string
  testId?: string
  style?: CSSProperties
  onClick?: EventHandler<MouseEvent<Element>> | undefined
}

const DEFAULT_PROPS: AButtonProps = {
  size: 'SM',
  type: 'outlined',
  hover: 'outlined',
  shape: 'default',
  disabled: false,
  highlight: false,
  loading: false,
  textWeight: 'bold',
}

const genHoverCls = (props: AButtonProps) => {
  const {
    type = DEFAULT_PROPS.type,
    hover = DEFAULT_PROPS.hover,
    disabled = DEFAULT_PROPS.disabled,
    loading = DEFAULT_PROPS.loading,
  } = props
  if (disabled || loading) {
    return ''
  }
  /** type = 'primary' 则不采用 hover 的类型 */
  return type === 'primary' ? 'primary' : hover
}

function AButton(props: AButtonProps) {
  const {
    size = DEFAULT_PROPS.size,
    type = DEFAULT_PROPS.type,
    // hover = DEFAULT_PROPS.hover,
    shape = DEFAULT_PROPS.shape,
    disabled = DEFAULT_PROPS.disabled,
    highlight = DEFAULT_PROPS.highlight,
    textWeight = DEFAULT_PROPS.textWeight,
    loading = DEFAULT_PROPS.loading,
    onClick,
    className,
    testId,
    style,
  } = props

  const _hover = genHoverCls(props)
  const classNames = cls(
    styles[COMPONENT_NAME],
    styles[`A-Button-type-${type}`],
    styles[`A-Button-size-${size}`],
    styles[`A-Button-shape-${shape}`],
    styles[`A-Button-text-weight-${textWeight}`],
    { [styles[`A-Button-hover-${_hover}`]]: _hover },
    { [styles['A-Button-highlight']]: highlight },
    { [styles['A-Button-disabled']]: disabled || loading },
    className
  )
  const handleClick = (e: MouseEvent<Element>) => {
    if (loading || disabled) {
      return
    }
    onClick?.(e)
  }

  return (
    <button data-testid={testId} className={classNames} disabled={props.disabled} style={style} onClick={handleClick}>
      {props.loading && (
        // 这里因为使用的字体原因，导致文字实际是偏上的，因此这里需要让 loading 偏上 1px
        <LoadingSpinner style={{ position: 'relative', top: -1 }} />
      )}
      {props.children}
    </button>
  )
}

export default AButton
